import { render, staticRenderFns } from "./JumBotronAdvance.vue?vue&type=template&id=2b9c26ae"
import script from "./JumBotronAdvance.vue?vue&type=script&lang=js"
export * from "./JumBotronAdvance.vue?vue&type=script&lang=js"
import style0 from "./JumBotronAdvance.vue?vue&type=style&index=0&id=2b9c26ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports